export const WAVE_URL = "WAVE_URL";
export const NOW_READY_URL = "NOW_READY_URL";